import axios from "axios";

export const FinancialUrl =
  "https://weviira-001-site1.jtempurl.com/api/";

const getFinancialToken = () => {
  return sessionStorage.getItem("financialAccessToken");
};

const financialRequest = async (method, endpoint, data = null) => {
  const token = getFinancialToken();

  if (!token) {
    throw new Error("Financial access token is missing");
  }

  return axios({
    method,
    url: `${FinancialUrl}${endpoint}`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const verifyFinancialPassword = async (password) => {
  return axios.post(
    `${FinancialUrl}FinancialAccess/verify`,
    {
      password,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export const changeFinancialPassword = async (
  currentPassword,
  newPassword
) => {
  const token = sessionStorage.getItem("financialAccessToken");

  if (!token) {
    throw new Error("Financial access token is missing");
  }

  return axios.post(
    `${FinancialUrl}FinancialAccess/change-password`,
    {
      currentPassword,
      newPassword,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const financialFetch = async (endpoint) => {
  const response = await financialRequest("GET", endpoint);

  return response.data;
};

export const financialPost = async (endpoint, data) => {
  const response = await financialRequest("POST", endpoint, data);

  return response;
};

export const financialPut = async (endpoint, data) => {
  const response = await financialRequest("PUT", endpoint, data);

  return response;
};

export const financialDelete = async (endpoint) => {
  const response = await financialRequest("DELETE", endpoint);

  return response;
};